export default "__VITE_ASSET__BxEFD4g$__"